import useTranslations from '@/hooks/useTranslations';
import IconButton from '@mui/material/IconButton';
import { Dispatch, SetStateAction } from 'react';
import InfoIcon from '@mui/icons-material/InfoOutlined';

interface props {
  setShowDescription: Dispatch<SetStateAction<boolean>>;
  showDescription: boolean;
  loading?: boolean;
}

export default function Description({ setShowDescription, showDescription, loading }: props) {
  const { t } = useTranslations();

  return (
    <IconButton
      onClick={() => setShowDescription(!showDescription)}
      color='secondary'
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: loading ? 1 : 3,
      }}
      aria-label={showDescription ? t('cards.hideInfo') : t('cards.showInfo')}
      disabled={loading}
    >
      <InfoIcon />
    </IconButton>
  );
}
